import React from 'react'
import { NavLink, useSearchParams } from 'react-router-dom'
import { equalString } from '@/util/strings.ts'

export interface INavItem {
    id: string
    label: string
    href: string
    tab?: string
}

export interface IProps extends INavItem {
    className?: string
}

const NotificationNavItem: React.FC<IProps> = ({ className, label, href, tab = '' }) => {
    const [searchParams] = useSearchParams()

    return (
        <div className={`${className} flex-none`}>
            <NavLink
                to={href}
                className={({ isActive }) =>
                    [
                        'notification-tab flex items-center justify-center min-h-[46px] px-[18px] py-[8px] font-medium text-[14px] min-w-[140px] sm:min-w-[120px]',
                        isActive && equalString(tab, searchParams?.get('tab') || '') ? 'notification-tab--active' : ''
                    ].join(' ')}>
                {label}
            </NavLink>
        </div>
    )
}

export default NotificationNavItem
